var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-multiline is-gapless"},_vm._l((_vm.photos),function(photo){return _c('div',{key:photo.id,staticClass:"column is-3"},[_c('PhotoQuestionImage',{attrs:{"photo":photo}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }